import React, { PureComponent } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {
  selectFormat,
  sortNumeric,
  Error,
  getMetricForColumn,
} from "components/Utils/Utils.js";
import filterFactory from "react-bootstrap-table2-filter";
import paginationFactory from "react-bootstrap-table2-paginator";
import Heading from "components/Elements/Heading";

class LeeWeeklyRateStratification extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  renderTable(dataTable, footerRow, cells) {
    const { title } = this.props;

    const selected_columns = [];

    dataTable.forEach((d, i) => {
      d.id = i;
    });

    const columns = [
      {
        dataField: "from",
        text: "From",
        csvFormatter: (cell) => cell,
        hidden: true,
      },
      {
        dataField: "to",
        text: "To",
        csvFormatter: (cell) => cell,
        hidden: true,
      },
      {
        dataField: "total",
        text: "Total",
        style: { width: "80px", minWidth: "80px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "number", format: "0" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0"),
        sort: true,
        sortFunc: sortNumeric,
        footer: footerRow["total"],
        footerFormatter: (col) => selectFormat("number", col.footer.value, "0"),
      },
      {
        dataField: "avg_weekly_range",
        text: "Avg Weekly Range",
        style: { width: "100px", minWidth: "100px", textAlign: "left" },
        headerAlign: "left",
        csvFormatter: (cell) => cell.value,
        formatter: (cellContent, row) => `${cellContent.value}`,
        footer: "Total",
      },
      {
        dataField: "avg_weekly_value",
        text: "Avg Weekly Value",
        style: { width: "100px", minWidth: "100px", textAlign: "left" },
        headerAlign: "left",
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage", format: "0.00" },
        csvFormatter: (cell) =>
          selectFormat("percentage", cell && cell.value, "0.00"),
        sort: true,
        sortFunc: sortNumeric,
        footer: "Total",
        hidden: true,
      },
      {
        dataField: "dsi_pct",
        text: "DSI %",
        style: { width: "80px", minWidth: "80px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage", format: "%0.00" },
        csvFormatter: (cell) =>
          selectFormat("percentage", cell && cell.value, "%0.00"),
        sort: true,
        sortFunc: sortNumeric,
        footer: footerRow["dsi_pct"],
        footerFormatter: (col) =>
          selectFormat("number", col.footer.value, "%0.00"),
      },
      {
        dataField: "dsi",
        text: "DSI",
        style: { width: "80px", minWidth: "80px", textAlign: "left" },
        headerAlign: "left",
        formatExtraData: { type: "number", format: "0" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) => selectFormat("number", cell && cell.value, "0"),
        sort: true,
        sortFunc: sortNumeric,
        footer: footerRow["dsi"],
        footerFormatter: (col) => selectFormat("number", col.footer.value, "0"),
      },

      {
        dataField: "falcon",
        text: "Falcon",
        style: { width: "80px", minWidth: "80px", textAlign: "left" },
        headerAlign: "left",
        formatter: getMetricForColumn,
        formatExtraData: { type: "number", format: "0" },
        csvFormatter: (cell) => selectFormat("number", cell && cell.value, "0"),
        sort: true,
        sortFunc: sortNumeric,
        footer: footerRow["falcon"],
        footerFormatter: (col) => selectFormat("number", col.footer.value, "0"),
      },
      {
        dataField: "falcon_pct",
        text: "Falcon %",
        style: { width: "80px", minWidth: "80px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage", format: "%0.00" },
        csvFormatter: (cell) =>
          selectFormat("percentage", cell && cell.value, "%0.00"),
        sort: true,
        sortFunc: sortNumeric,
        footer: footerRow["falcon_pct"],
        footerFormatter: (col) =>
          selectFormat("number", col.footer.value, "%0.00"),
      },

      {
        dataField: "stl",
        text: "Stl",
        style: { width: "80px", minWidth: "80px", textAlign: "left" },
        headerAlign: "left",
        formatExtraData: { type: "number", format: "0" },
        csvFormatter: (cell) => selectFormat("number", cell && cell.value, "0"),
        formatter: getMetricForColumn,
        sort: true,
        sortFunc: sortNumeric,
        footer: footerRow["stl"],
        footerFormatter: (col) => selectFormat("number", col.footer.value, "0"),
      },
      {
        dataField: "stl_pct",
        text: "Stl %",
        style: { width: "80px", minWidth: "80px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage", format: "%0.00" },
        csvFormatter: (cell) =>
          selectFormat("percentage", cell && cell.value, "%0.00"),
        sort: true,
        sortFunc: sortNumeric,
        footer: footerRow["stl_pct"],
        footerFormatter: (col) =>
          selectFormat("number", col.footer.value, "%0.00"),
      },

      {
        dataField: "buffalo",
        text: "Buffalo",
        style: { width: "80px", minWidth: "80px", textAlign: "left" },
        headerAlign: "left",
        formatter: getMetricForColumn,
        formatExtraData: { type: "number", format: "0" },
        csvFormatter: (cell) => selectFormat("number", cell && cell.value, "0"),
        sort: true,
        sortFunc: sortNumeric,
        footer: footerRow["buffalo"],
        footerFormatter: (col) => selectFormat("number", col.footer.value, "0"),
      },
      {
        dataField: "buffalo_pct",
        text: "Buffalo %",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage", format: "%0.00" },
        csvFormatter: (cell) =>
          selectFormat("percentage", cell && cell.value, "%0.00"),
        sort: true,
        sortFunc: sortNumeric,
        footer: footerRow["buffalo_pct"],
        footerFormatter: (col) => selectFormat("number", col.footer.value, "%"),
      },
    ];

    cells.forEach((cell, i) => {
      selected_columns.push(columns.find((o) => o.dataField === cell));
    });

    const pagination = paginationFactory({
      sizePerPage: 20,
      hideSizePerPage: true,
    });

    const filename = title.split(" ").join("_") || "spreadsheet";

    return (
      <>
        <Heading size={6} key={"heading"}>
          We do not have rate breakdowns for STL and Buffalo at the moment. So
          they are all lumped into the $0-$0.49 group.
        </Heading>

        <ToolkitProvider
          keyField="id"
          data={dataTable}
          columns={selected_columns}
          striped={false}
          hover={false}
          bordered={false}
          exportCSV={{
            fileName: filename + ".csv",
            exportAll: false,
            onlyExportFiltered: true,
          }}
        >
          {(props) => (
            <BootstrapTable
              {...props.baseProps}
              {...props.csvProps}
              filter={filterFactory()}
              footerClasses={"tfoot__tr"}
              pagination={pagination}
              ref={(el) => (this.childRef = el)}
            />
          )}
        </ToolkitProvider>
      </>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data, cells } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    const dataTable = data.data.slice(0, -1);
    const footerRow = data.data[data.data.length - 1];

    return this.renderTable(dataTable, footerRow, cells);
  }
}

export default LeeWeeklyRateStratification;
